<template>
  <div class="page">
    <main-menu-bar/>
    <div class="page-inner">
      <p>Ontime</p>
      <ontime-timer
        :url="ontimeUrl"
        :config="{
            onEnd: 'showNegative'
        }"
        />
    </div>
  </div>
</template>

<script>
import MainMenuBar from '../nav/MainMenuBar.vue'
import OntimeTimer from './OntimeTimer.vue'

export default {
  name: 'OntimeScreen',
  components: {
    MainMenuBar,
    OntimeTimer
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  computed: {
    ontimeUrl () {
      return this.$store.getters['settings/ontimeUrl']
    },
    hasAccess () {
      if (!this.$store.getters['auth/authenticated']) {
        return false
      }
      return true
      /**
      return this.$store.getters['auth/user'].hasRole([
        Role.OPERATOR,
        Role.ADMIN
      ])
      **/
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ontime/OntimeScreen.vue